import { render } from "./PriceCard.vue?vue&type=template&id=81df4d12&scoped=true"
import script from "./PriceCard.vue?vue&type=script&lang=js"
export * from "./PriceCard.vue?vue&type=script&lang=js"

import "./PriceCard.vue?vue&type=style&index=0&id=81df4d12&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81df4d12"]])

export default __exports__